const maskSelector = '.loading-mask';

export default {
    bind (el, { value }) {
        el.classList.add('loading-mask__parent');

        const loaderContainer = document.createElement('div');

        loaderContainer.classList.add('loading-mask');
        loaderContainer.classList[value ? 'remove' : 'add']('loading-mask--hide');

        el.append(loaderContainer);

        const loader = document.createElement('div');
        loader.classList.add('vloader');
        loaderContainer.append(loader);

        for (let i = 0; i < 2; i++) {
            const loaderItem = document.createElement('div');
            loaderItem.classList.add('vloader__item');
            loader.append(loaderItem);
        }
    },
    update (el, { value }) {
        const mask = el.querySelector(maskSelector);

        mask.classList[value ? 'remove' : 'add']('loading-mask--hide');
    },
    unbind (el) {
        const mask = el.querySelector(maskSelector);
        if (mask) {
            el.querySelector(maskSelector).remove();
        }

        if (el.classList.contains('loading-mask__parent')) {
            el.classList.remove('loading-mask__parent');
        }
    },
};
